<template>
    <div class="content-body customers-wrapper customer-list">
        <div>
            <customer-topic-table></customer-topic-table>
        </div>
        <div>
            <customer-feedback-table></customer-feedback-table>
        </div>
    </div>
</template>

<script>
import CustomerTopicTable from "./CustomerTopicTable.vue";
import CustomerFeedbackTable from "./CustomerFeedbackTable.vue";

export default {
    name: "Feedbacks",
    components: {
        "customer-topic-table": CustomerTopicTable,
        "customer-feedback-table": CustomerFeedbackTable
    }
};
</script>
